import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import type { ReactNode } from 'react';
import styles from './PageContent.module.scss';
export type PageContentSize = 'default' | 'sm' | 'md' | 'full';

/**
 * A page's text column (policies, disclosures, financial aid). It keeps the
 * page's intro offset above it (140px under the header) and no space below
 * it: the section after it, or the site footer, starts one section-rhythm run
 * (P) below its last line.
 */
export interface PageContentProps {
  children: ReactNode;
  size?: PageContentSize;
}
function PageContent(t0) {
  const $ = _c(5);
  const {
    children,
    size: t1
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  const t2 = styles[`helios-page-content__inner--${size}`];
  let t3;
  if ($[0] !== t2) {
    t3 = classNames(styles["helios-page-content__inner"], t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children || $[3] !== t3) {
    t4 = <div className={styles["helios-page-content"]} data-helios-section=""><div className={t3}>{children}</div></div>;
    $[2] = children;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
export default PageContent;